import React, { Component } from "react";
import PropTypes from 'prop-types';
import {
  MemoryRouter, 
  Switch,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";
import { base, auth, app } from "./base";
import logo from "./on-golf-logo-new-137.png";
import BigCalendar from "react-big-calendar";
//import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import "react-big-calendar/lib/css/react-big-calendar.css";


import moment from "moment";
import "moment/locale/de"
import Login from "./Login";
//import Register from "./Register";
import EventDetail from "./EventDetail";
import EventUpdate from "./EventUpdate";
import AddNewEvent from "./AddNewEvent";
import AlertBox from "./AlertBox";
import ImportCalendarEvents from "./ImportCalendarEvents";
import MyStatelessComp from './MyStatelessComp';
import SendUserEmails from './SendUserEmails';

import axios from 'axios';

import "./App.css";
import Register from "./Register";
import Papa from "papaparse";


// https://github.com/intljusticemission/react-big-calendar/blob/master/examples/demos/dnd.js
//const DragAndDropCalendar = withDragAndDrop(BigCalendar);

class App extends Component {
  constructor(props, state) {
    super(props);
    this.state = state;
    moment.locale('de');
    console.log( " moment.locale()",moment.locale());

    BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));
    this.goToDetail = false;
    this.state = {
      navTargetPath : '/',
      //goToDetail: false,
      //goToAddNewEvent: false,
      //goToNotauthenticated: false,
      authenticated: false,
      isverified: false,
      user: null,
      userName: "",
      userRole: "guest",
      idCounter: 0,
      newName: "",
      startDate: moment(),
      endDate: moment(),
      events: [],
      data: {},
      users: [],
      roleClass : 'is-guest', 
      currentEvent: null
    };
    this.updateEvent = this.updateEvent.bind(this);
    this.joinEvent = this.joinEvent.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
    this.onNewUser = this.onNewUser.bind(this);
    this.logOut = this.logOut.bind(this);
    this.addNewEvent = this.addNewEvent.bind(this);
    this.selectEvent = this.selectEvent.bind(this);
    this.selectSlot = this.selectSlot.bind(this);
    this.hideNewEvent = this.hideNewEvent.bind(this);
    this.closeEventDetails = this.closeEventDetails.bind(this);
    this.resetRoutes = this.resetRoutes.bind(this);
    this.eventStyleGetter = this.eventStyleGetter.bind(this);
    this.removeEvent = this.removeEvent.bind(this);
    this.validateUserName = this.validateUserName.bind(this);
    this.onRemoveParticipant = this.onRemoveParticipant.bind(this);
    this.onImportEventsData = this.onImportEventsData.bind(this);
    // Initialize Firebase
    this.base = base;
    this.reloginAfterNewUser = false;
    this.userEMail='';
    this.userPassword='';
    this.eventColor="#0D98BA";
  }

  validateUserName(userName){
    console.log("App validateUserName() ",userName);
    let uniqueUsernames = this.state.users.filter( user => {
        return user.displayName===userName
    });
    return uniqueUsernames.length===0;
  }

  createEventsFromImportedData(eventsArray){
    console.log('createEventsFromImportedData',eventsArray);
    let EVENTS_DATA=eventsArray;
    let UPDATED_EVENTS = eventsArray.map((item)=>{
      let description = `
  Platz : ${item.Platz}
  SpielForm : ${item.SpielForm}
  Teilnehmer : ${item.Teilnehmer}
  Spielleitung : ${item.Spielleitung}
  Vorgabe : ${item.Vorgabe.replace('#ERROR!','+')}
  Bemerkungen : ${item.Bemerkungen}
  Kommentare : ${item.Kommentare}
  
      `;
      let startDate=item.Datum + ' '+item.Zeit;
      startDate=startDate.replace('*','');
      startDate = startDate.replace('.','/');
      startDate = startDate.replace('.','/');
      console.log("startDate1",startDate);
      startDate= moment(startDate,'DD-MM-YY HH:mm');
      
      let newEvent = {
        id: moment().unix(),
        title: "Seniorenkreis",
        description: description,
        duration: 2,
        createdBy: this.state.user.email,
        participants: [this.state.user.email],
        startDate: startDate,
        end: moment(startDate)
          .add(3, "hours")
          .toDate()
          .toISOString(), 
        color: 'blue'
      };
      return newEvent;
    });

    console.table(UPDATED_EVENTS);
    return UPDATED_EVENTS;
  }


  navigateTo(where){
    const { router } = this.context;
    router.transitionTo('/login');
  }

  redirectToInitialState() {
    console.log("App redirectToInitialState() ");
    this.setState({
      navTargetPath : '/'
    });
  }

  componentWillMount() {}

  componentDidMount() {
    console.log("componentDidMount() ");
    //this.sendApprovalEmail(); 

    this.usersRef = base.syncState(`users`, {
      context: this,
      state: "users",
      asArray: true,
      keepKeys: true
    });
    console.log("!!!!!!!!!!!!!!!!!!App : componentDidMount ",this.state.users);
    this.base.listenTo(`users`, {
      context: this, 
      asArray: true,
      then(usersListData) {
        if(this.state.user){
          console.log("!!listenTo", usersListData,this.state.user.email);
          let isAdmin = usersListData.some( userItem => (userItem.role==='admin' && userItem.username===this.state.user.email));
          isAdmin && this.setState({roleClass:'is-admin',user:{...this.state.user,role:'admin'}});
          this.checkVerified(usersListData);
          console.log("App : isAdmin",isAdmin,this.state.users);
        }
        
      }
    });
    this.base.listenTo(`eventsList`, {
      context: this,
      asArray: true,
      then(eventsListData) {
        console.log("listenTo", eventsListData);
        let events = eventsListData.map(event => {
          console.log(event);
          //let eventItem = event;
          event["start"] = moment(event["start"]).toDate();
          event["end"] = moment(event["end"]).toDate();
          return event;
        });
        console.log("events", events);
        this.setState({
          events: events
        });
      }
    });

    auth.onAuthStateChanged((user) => {
      console.log("!!!!!!!!!!!!!!!!!!App : auth.onAuthStateChanged (user) this.reloginAfterNewUser",this.reloginAfterNewUser);
      if (user) {
        this.setState({ user :{
          id : user.uid,
          email : user.email,
          displayName: user.displayName,
          role : 'guest'
        } , authenticated: true });
        // get user roles
        console.log("this.state.users",this.state.users);
        this.checkVerified(this.state.users);
        //this.redirectToInitialState();
      } else {
        this.setState({
          user: null,
          authenticated: false
        });
        if(this.reloginAfterNewUser){
          setTimeout(()=>{
            console.log("this",this);
            console.log("this.userEMail",this.userEMail);
            console.log("setTimeout this.userEMail",this.userEMail);
            auth.signInWithEmailAndPassword(this.userEMail,this.userPassword);
          },1000);
        }
      }
    });
  }
  checkVerified(usersListData){
    let isverified = usersListData.filter( userItem => (userItem.verified===true && userItem.username===this.state.user.email)).length>0;
    if(isverified){
      this.setState({isverified:true});
      this.setState({user:{
        ...this.state.user,
        verified:true
      }});
    }
  }

  logOut() {
    console.log("app logout()");

    auth.signOut();
  }

  onUserLogin(user,displayName,email,password){
    //this.reloginAfterNewUser=true;
    //let isverified = this.state.users.filter( userItem => (userItem.verified===true && userItem.username===this.state.user.email)).length>0;
    this.reloginAfterNewUser = true;
    console.log("app onUserLogin() isverified",this.state.users);     
    // retinafunk@gmail.com  
  }

  onNewUser(user,displayName,email,password) {
    console.log("1app onNewUser user,displayName", user,displayName);
    this.userEMail=email;
    this.userPassword=password;
    this.reloginAfterNewUser=true;
    // add user to firebase
    const newUser = {
      key: user.uid,
      username: user.email,
      displayName : displayName,
      role: "guest",
      verified: false,
      provider: "email-password"
    }; 
    console.log("3app onNewUser newUser: ", newUser);
    this.setState({
      users: [...this.state.users, newUser]
    });
    
    console.log("4::S::::::::app onNewUser users :  ", this.state.users,user.uid);
    this.sendApprovalEmail(user.email,displayName,user.uid); 
    this.redirectToInitialState();
    this.logOut();
  }

  // select an event and show event detail
  selectEvent(event) {
    if (this.state.authenticated && this.state.user.verified) {
      console.log("selectEvent", event);
      //this.props.history.push("/event-detail");
      this.setState({
        currentEvent: event,
        navTargetPath : '/event-detail'
      });
    } else {
      this.setState({
        //goToNotauthenticated : true
        navTargetPath : '/not-authenticated'
      });
    }
  }

  // select a time slot and show new , set event start date time to selected time slot
  selectSlot(slot) {
    if (this.state.authenticated && this.state.user.verified) {
      console.log("selectSlot", typeof slot.start, slot.start);
      this.setState({
        startDate: moment(slot.start) 
      });
      this.setState({
        //goToAddNewEvent: true
        navTargetPath  : 'event-add-new'
      });
    } else {
      //alert(`You must be logged in to add events!`);
      this.setState({
        //goToNotauthenticated : true
        navTargetPath  : 'not-authenticated' 
      });
      console.warn("you can only add events when logged in");
    }
  }

  // custom colors styles for calendar events
  // TODO green for admin events , orange for user events
  eventStyleGetter(event, start, end, isSelected) {
    let color= event.color;
    if(color=='#FF8000'){
      color ='rgb(13, 152, 186)';
    }
    var style = {
      backgroundColor: color || "green"
    };
    return {
      style: style
    };
  }

  // hide the new event box
  hideNewEvent() {
    console.log('App : hideNewEvent()');
    this.setState({
      //goToAddNewEvent: false
      navTargetPath  : '/'
    });
  }
  resetRoutes() {
    console.log('App : resetRoutes()');
    this.setState({
      //goToAddNewEvent: false,
      //goToNotauthenticated: false,
      //goToDetail: false
      navTargetPath  : '/'
    });
  }
  closeEventDetails() {
    console.log('App : closeEventDetails()');
    this.setState({
    navTargetPath : '/'
    })
  }
  
  // add a new event
  addNewEvent(event,isImport = false) {
    console.log('App : addNewEvent(event)',event);
    this.setState({
      idCounter: this.state.idCounter + 1
    });
    let eventColor = this.state.user.role === 'admin' ? 'Orange' : 'DodgerBlue';
    eventColor = isImport ? 'DarkCyan' : eventColor;
    let newEvent = {
      id: moment().unix(),
      title: event.title,
      description: event.description,
      duration: event.duration,
      createdBy: this.state.user.email,
      participants: [this.state.user.email],
      start: event.startDate.toDate().toISOString(),
      end: moment(event.startDate)
        .add(event.duration, "hours")
        .toDate()
        .toISOString(),
      color: eventColor
    };

    this.base.push(`eventsList`, {
      data: newEvent,
      then(err) {
        if (!err) {
          //Router.transitionTo('dashboard');
        }
      }
    });
  }

  onRemoveParticipant(participant){
    console.log('App : onRemoveParticipant(participant)',participant);
    let participants=[...this.state.currentEvent.participants];
    if(participants.length>1) participants.splice(participants.indexOf(participant),1);
    if(participants.length<1){
      participants =[];
    }
    
    this.setState({
      currentEvent :{
        ...this.state.currentEvent,
        participants : participants
      }
    });

    this.base.update(`eventsList/${this.state.currentEvent.key}`,{
      data: {
        participants : participants
      }
    });
    console.log('App : onRemoveParticipant participants',participants,participants.indexOf(participant));
  }

  removeEvent(event){
    console.log('App : removeEvent(event)',event);
    const key=event.key;
    this.base.remove(`eventsList/${key}`,(err)=>{
      console.log('App : removed event',err);
      if(!err) this.closeEventDetails()
    });
  }

  updateEvent(event){
    console.log('App : updateEvent(event)',event);
    const key=this.state.currentEvent.key;

      const participants=this.state.currentEvent.participants;
      
      this.base.update(`eventsList/${key}`,{
        data :{
          title : event.title,
          duration : event.duration,
          description : event.description,
          start :event.startDate.toDate().toISOString(),
          end: moment(event.startDate)
              .add(event.duration, "hours")
              .toDate()
              .toISOString(),
    
        },
        then(err){
          if(!err){
            
          }
        }
      });
  }

  joinEvent(user){ 
    console.clear();
      console.log("App : joinEvent ; ",user.email,this.state.currentEvent.participants); 
      const key=this.state.currentEvent.key;
      const participants=[...this.state.currentEvent.participants,user.email];
      this.base.update(`eventsList/${key}`,{
        data :{
          participants : participants
        },
        then(err){
          if(!err){
            
          }
        }
      });
   
  }
  sendApprovalEmail(userEmail,userName,userId){
    console.log("App -> sendApprovalEmail()");
    // https://www.on-golf.de/calendar/send-new-user-approval-email.php
     const URL=`https://www.on-golf.de/calendar/send-new-user-approval-email.php?email=${userEmail}&userName=${userName}&userId=${userId}`;
     axios.get(URL).then((response)=>{
       console.log('API response',response);
     }).catch(err=>console.error(err));
     
  }
  componentWillUnmount() {
    //this.dbCon.off();
  }
  componentWillUpdate() {
    //console.log("componentWillUpdate()", this.state);
  }
  componentDidUpdate() {

  }

  onImportEventsData(eventsList){
    console.log("App onImportEventsData()",this,this.addNewEvent,eventsList);
    for(let i=0;i<eventsList.length;i++){
      this.addNewEvent(eventsList[i]);
      setTimeout(()=>{
        
      },2000);
    }
  }

  render() { 
    return (
      <MemoryRouter>
        <div className="App container">
          <header className="App-nav-container">
            <nav className="App-nav">
                {this.state.user ? (
                  <div className="columns is-multiline">
                    <div className="column is-full">
                      <button className={`button is-white is-small ${this.state.roleClass}`} ><ion-icon name="person" size="large"></ion-icon>
                      &nbsp;{this.state.user.displayName} 
                      
                      <span className="small "> ({this.state.user.role}) </span>
                          <span className="small ">{this.state.user.verified===true &&  <div className="success" > <ion-icon name="checkmark"></ion-icon> Nutzer freigeschaltet! </div> } </span>
                          <span className="small">{(this.state.user.verified===false || !this.state.user.verified) && <div className="warning"> <ion-icon name="warning"></ion-icon> Nutzer noch nicht freigeschaltet! </div>} </span>
                      </button> 
                    </div> 
                    <div className="column is-narrow">
                        <button className="button is-small is-danger nav-item " onClick={this.logOut}><ion-icon name="log-out"></ion-icon> Abmelden</button>
                    </div>  
                    {this.state.user.role==="admin" ?  <div className="admin-nav column"> 
                      <Link className="button is-white  is-small nav-item" to="/import-events">TERMINE IMPORTIEREN</Link>
                      <Link className="button is-white  is-small nav-item" to="/send-user-emails">E-MAILS SENDEN!</Link>
                     </div>   : ''}
                  </div>
    
                ) : (
                  <div> 
                    <Link className="button is-white App-nav-button nav-item"  to="/login"><ion-icon name="log-in"></ion-icon>&nbsp; Anmelden </Link>
                    <Link className="button is-white App-nav-button nav-item"  to="/register"><ion-icon name="person-add"></ion-icon>&nbsp; Registrieren</Link>
                  </div>
                )}
              </nav>
          </header>
          <Switch>
            <Route
              exact
              path="/"
              render={() =>{
                if(this.state.navTargetPath!=='/'){
                  return (<Redirect to={this.state.navTargetPath} />);
                }else {
                  console.log('No redirect');
                  return (<div></div>);
                }
              }}
            />
            <Route
              exact
              path="/login"
              render={() => <Login validateUserName={this.validateUserName} onUserLogin={this.onUserLogin} />}
            />
             <Route
              exact
              path="/Register"
              render={() => <Register validateUserName={this.validateUserName} onNewUser={this.onNewUser} />}
            />           
            <Route
              exact
              path="/event-detail"
              render={() => <EventDetail event={this.state.currentEvent} onClose={this.resetRoutes} onRemoveEvent={this.removeEvent} currentUser={this.state.user} onJoin={this.joinEvent} onRemoveParticipant={this.onRemoveParticipant}   />}
            />
            <Route
              exact
              path="/event-add-new"
              render={() => <AddNewEvent startDate={this.state.startDate} onAddNewEvent={this.addNewEvent} onClose={this.resetRoutes} />}
            />
            <Route
              exact
              path="/event-update"
              render={() => <EventUpdate startDate={this.state.currentEvent.start}  event={this.state.currentEvent} onClose={this.resetRoutes} onUpdateEvent={this.updateEvent} currentUser={this.state.user} onJoin={this.joinEvent} onRemoveParticipant={this.onRemoveParticipant}   />}
            />
            <Route
              exact
              path="/send-user-emails"
              render={() => <SendUserEmails users={this.state.users}  />}
            />
             <Route
              exact
              path="/import-events"
              render={() => <ImportCalendarEvents user={this.state.user} onImportEventsData={this.onImportEventsData}   />}
            />
            <Route
              exact
              path="/not-authenticated"
              render={() => <AlertBox headline="Nutzer nicht angemeldet!" msg="Bitte melden Sie sich an.Sie müssen registriert, verifiziert und hier angemeldet sein um Events &amp; Termine zu nutzen! " onClose={this.resetRoutes}  >
                <Link className="button is-success App-nav-button"  to="/login"><ion-icon name="log-in"></ion-icon>&nbsp; Anmelden </Link>

<Link className="button is-info App-nav-button"  to="/register"><ion-icon name="person-add"></ion-icon>&nbsp; Registrieren</Link>

              </AlertBox>}
            />
          </Switch>

          {/* mail big calendar component to show events and add new */}
          <div className="calendar-container">
            <BigCalendar
              events={this.state.events}
              selectable={true}
              step={15}  
              culture={'de'}
              timeslots={8}
              defaultDate={new Date()}
              onSelectEvent={this.selectEvent}
              onSelectSlot={this.selectSlot}
              eventPropGetter={this.eventStyleGetter}
              messages={{next:'weiter >',previous:'< zurück',today:'Heute',month:'Monat',week:'Woche',day:'Tag'}}
            />
          </div>
        </div>
      </MemoryRouter>
    );
  }
}
 
App.contextTypes = {
  router: PropTypes.object
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js